export const getMarkets = () => {
    return ['en', 'sk', 'cz', 'pl', 'hu', 'ro'];
};
